import { render } from "./ButtonGoCreate.vue?vue&type=template&id=53092fc5"
import script from "./ButtonGoCreate.vue?vue&type=script&lang=js"
export * from "./ButtonGoCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__